import { z } from 'zod'

const CVStepUploadFileSchema = z.object({
  cvFile:
    typeof window === 'undefined'
      ? z.null()
      : z.instanceof(File, 'custom.cvFile')
})

export default CVStepUploadFileSchema
